module.exports = __webpack_public_path__ + "img/fr-FR-add-to-apple-wallet.edcb027.svg";